export const homeEn = {
  hero: {
    title: 'Authentic Italian Flavors in the Heart of Reykjavik',
    subtitle:
      'Experience the true taste of Naples at the best Italian restaurant in Reykjavik. Wood-fired pizza, fresh pasta, and warm Italian hospitality in downtown Reykjavik.',
    buttons: {
      bookTable: 'Book a Table',
      exploreMenu: 'Explore Menu',
    },
  },
  aboutPreview: {
    title: 'Our Story',
    subtitle:
      'Founded in Naples in 1988, Rossopomodoro brings the authentic taste of Italy to downtown Reykjavik.',
    since: 'Since 2006',
    content: [
      "At Rossopomodoro Reykjavik, we're passionate about sharing the true flavors of Naples in the heart of Iceland's capital. Our chefs use traditional techniques and the finest ingredients imported directly from Italy, combined with the best local Icelandic produce to create the most authentic Italian food in Reykjavik.",
      "Every pizza is crafted following the strict guidelines of Neapolitan pizza-making tradition, and baked in our wood-fired oven imported directly from Italy. Located on Laugavegur, Reykjavik's main shopping street, we've been serving the best pizza in Reykjavik since 2006. Our pasta is made fresh daily, and our wines are carefully selected to complement the distinctive flavors of our cuisine.",
    ],
    button: 'Learn More About Us',
  },
  infoOverview: {
    location: {
      title: 'Find Us',
      getDirections: 'Get Directions',
    },
    menuStats: {
      title: 'Our Menu',
      subtitle: 'Authentic Italian dishes made fresh daily',
      pizzas: {
        category: 'Wood-Fired Pizzas',
        count: '17',
      },
      pasta: {
        category: 'Two Decades of Experience',
        count: 'Est. 2006',
      },
      other: {
        category: 'Happy Customers',
        count: 'infinity',
      },
    },
    hours: {
      title: 'Hours',
      openStatus: 'We are open!',
      closedStatus: 'We are closed',
      openTill: 'Open till',
      opensNext: 'Opens',
      today: 'today at',
      tomorrow: 'tomorrow at',
      at: 'at',
      callUs: 'Call us: +354 561 0500',
      schedule: {
        weekdays: 'Monday - Saturday',
        weekdaysTime: '12:00 - 22:00',
        sunday: 'Sunday',
        sundayTime: '17:00 - 22:00',
      },
    },
  },
  menuPreview: {
    title: 'Our Menu Highlights',
    subtitle:
      'Experience our most popular dishes made with authentic Italian recipes and the freshest ingredients. Enjoy the best pizza in Reykjavik, made in our traditional wood-fired oven.',
    button: 'View Full Menu',
  },
  testimonials: {
    title: 'What Our Guests Say',
    subtitle:
      "Don't just take our word for it - here's what our guests have to say about their dining experience",
    readMore: {
      text: 'Read more reviews from our guests:',
      facebook: 'Facebook Reviews',
      google: 'Google Reviews',
    },
  },
  reservation: {
    title: 'Book Your Table',
    subtitle: 'Reserve your table today and enjoy an authentic Italian dining experience',
    description:
      "Whether it's a romantic dinner, family gathering, or business lunch, we're here to make your occasion special.",
    form: {
      guestInfoTitle: 'Guest Information',
      reservationDetailsTitle: 'Reservation Details',
      name: 'Full Name',
      email: 'Email Address',
      phone: 'Phone Number (optional)',
      guests: 'Number of Guests',
      date: 'Date',
      time: 'Time',
      note: 'Add a note (optional)',
      button: 'Request Reservation',
      submitting: 'Booking...',
      confirmation:
        'Your reservation request has been sent successfully. We will confirm your booking shortly via email!',
      defaultNote: 'You will receive a confirmation email once your reservation is confirmed.',
      errorMessage: 'Failed to send reservation request. Please try again later.',
      placeholders: {
        name: 'Your name',
        email: 'Your email',
        phone: 'Your phone number',
        date: 'Select your preferred date',
        note: 'Any special requests, dietary requirements, or celebration details...',
      },
      timeOptions: {
        select: 'Select time',
      },
      guestOptions: {
        guest: 'Guest',
        guests: 'Guests',
        nineplus: '9+ Guests',
      },
    },
  },
};
